export { default as HomePage } from './Home';
export {
  Categories as CategoriesPage,
  Featured as FeaturedPage,
  MostPopular as MostPopularPage,
  RecentlyAdded as RecentlyAddedPage
} from './Listings';
export { default as SearchPage } from './Search';
export { default as MyAppsPage } from './MyApps';
export { default as DetailsPage } from './Details';
